<canvas
    #canvas
    class="stage"
    width="{{ viewport.width }}"
    height="{{ viewport.height }}"
    (mousedown)="mouseDown($event)"
    [class.no-cursor]="enableYondu"
    [style.cursor]="cursor"
></canvas>
<div
    #yondu
    class="yondu"
    [class.hidden]="!enableYondu"
    [style.top.px]="mousePos.y"
    [style.left.px]="mousePos.x"
    [style.transform]="'rotate(' + mouseRot + 'deg)'"
></div>

<div [hidden]="true">{{vm$ | async}}</div>
<div [hidden]="true">{{annotations$ | async}}</div>
